<script setup lang="ts"></script>

<template>
  <div>Розділ в розробці</div>
</template>

<style scoped lang="scss"></style>
